import { useTheme } from "@mui/material";
import { useContext, useMemo } from "react";
import { grey } from "@mui/material/colors";
import { withEmotionCache } from "@emotion/react";
import { EditorCtx } from "../wysiwyg/EditorCtx";

export const ThemeGlobalStyles = withEmotionCache((props, cache) => {
  const theme = useTheme();
  const { liveConfig, isEditor } = useContext(EditorCtx);
  const style = useMemo(
    () => (
      <style nonce={cache.nonce}>
        {(() => `
          html, body, #root, #__next {
            font-family: ${theme.settings.fonts.body.fontFamily};
            scrollbar-width: ${theme.settings.hideScrollBar ? "none" : "thin"};
            scrollbar-color: ${grey[300]};
            background-color: ${theme.palette.background.default};
            ${isEditor ? "overflow: hidden" : "overflow-x: hidden"};
          }

          ::-webkit-scrollbar {
            width: ${theme.settings.hideScrollBar ? "0rem" : ".5rem"};
          }
          
          .MuiChip-label {
            font-size: 0.9rem;
          }
        `)()}
      </style>
    ),
    [theme, liveConfig],
  );
  return style;
});
